import React, { useState } from 'react';
import { Container, Box, Typography, IconButton, Link } from '@mui/material';
import styles from './SponsorForm.module.css';
import { StyledEngineProvider } from '@mui/material/styles';
import HeaderCard from '../../layout/customs/header/HeaderCard';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import HelpIcon from '@mui/icons-material/Help';
import FAQDialog from './FAQDialog';
import DropoffDetailDialog from '../DropoffDetailDialog';

const SponsorFormContainer = (props) => {
  const [openFAQS, setOpenFAQS] = useState(false);
  const [openDropoff, setOpenDropoff] = useState(false);

  return (
    <StyledEngineProvider injectFirst>
      <Container>
        <HeaderCard
          title='Angel Sponsorship Registration'
          icon={
            <img
              src='/assets/images/sponsor_form_icon.png'
              alt='Sponsor Form Icon'
              style={{ width: 60, height: 60 }}
            />
          }
        />
        <Box className={styles.mainBox} color={'whiteText.main'}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant='body1' component='p' gutterBottom>
              Sponsorships are open to UFV and local community members. This is
              an opportunity for you to support and make a difference to
              someone's holiday season by sponsoring one or more Angels.
            </Typography>
            <Box>
              <IconButton
                color='secondary'
                aria-label='help'
                sx={{ fontSize: '30px' }}
                onClick={() => setOpenFAQS((prev) => !prev)}
              >
                <HelpIcon fontSize='inherit' />
              </IconButton>
              <Link
                href='#'
                onClick={() => setOpenFAQS((prev) => !prev)}
                color='inherit'
              >
                Frequently Asked Questions
              </Link>
            </Box>
            <Box>
              <IconButton
                color='secondary'
                aria-label='help'
                sx={{ fontSize: '30px' }}
                onClick={() => setOpenDropoff((prev) => !prev)}
              >
                <LocationOnIcon fontSize='inherit' />
              </IconButton>
              <Link
                href='#'
                variant='body1'
                color='inherit'
                onClick={() => setOpenDropoff((prev) => !prev)}
              >
                Drop-off Detail
              </Link>
            </Box>
          </Box>
        </Box>
      </Container>
      <FAQDialog open={openFAQS} setOpen={setOpenFAQS} />
      <DropoffDetailDialog open={openDropoff} setOpen={setOpenDropoff} />
      {props.children}
    </StyledEngineProvider>
  );
};

export default SponsorFormContainer;
